import VacationImport from '@/views/VacationImport.vue'

let routes = {
    path: '/vacation-import',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/vacation-import',
            name: 'vacation-import',
            component: VacationImport,
            meta: {
                pageTitle: 'Importar Férias',
                breadcrumb: [
                    { text: 'Importar Férias', active: true },
                ],
            },
        }
    ]
};

export default routes
